import { Company } from './../../models/system/company.model';
import { Component, OnInit } from '@angular/core';
import { setWAlert } from '@app/actions/w-alert.action';
import { MyProgramConstant } from '@app/common/constant/my-program.constant';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { MyProgram } from '@app/models/system/my-program.model';
import { getMyPrograms, MyProgramState } from '@app/selectors/system/my-program.selector';
import { WAlertState } from '@app/selectors/w-alert.selector';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { loadCompany } from '../../actions/system/company.actions';
import { CompanyState, getCompany } from '../../selectors/system/company.selector'
import { ValidationUtil } from '@app/common/util/validation.util';
import { NavigationEnd, Router } from '@angular/router';

declare const backToTop: any;

@Component({
  selector: 'hp-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  company$ = new Observable<Company>();

  company: Company = {} as Company;

  footerMenu: MyProgram[] = [];
  sidebarMenu: MyProgram[] = [];
  isNotTechRoute: boolean = true;

  constructor(
    private _companyStore: Store<CompanyState>,
    private _myProgramStore: Store<MyProgramState>,
    private _translateService: TranslateService,
    private wAlertStore: Store<WAlertState>,
    private router: Router
  ) { 
    this.company$ = this._companyStore.select(getCompany);
    
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isNotTechRoute = !event.url.includes('/tech');
      }
    });
  }
  
  ngOnInit(): void {  
    this._companyStore.dispatch(loadCompany());

    this._myProgramStore.select(getMyPrograms).subscribe(res => {
      this.footerMenu = res.filter(y => y.prgKind == MyProgramConstant.kindMenuFooter);
      this.sidebarMenu = res.filter(y => y.prgKind == MyProgramConstant.kindSidebar);
    });

    this.company$.subscribe(res =>{
      if(ValidationUtil.isNotNullAndNotEmpty(res)){
        this.company = res;
      }
    })
  }

  handleOnClickBackToTop(): void {
    if (typeof backToTop === "function") {
      backToTop();
    }
  }

  handleOnClickFooterMenuItem() {
    this.wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.warning, message: this._translateService.instant('comming-soon') } }));
  }

}
